import { PBAFunctionalAnalysis as Component } from './component';
import Connector from './connector';

export const PBAFunctionalAnalysis = () => <Connector component={Component} />;
